<template>
    <div>
        <label>{{resource('IOFormat_Csv_Upload_Header')}} *</label>
        <div>
            <file-upload accept=".csv" v-model="newFile" />
            <required-error fieldName="CSV File" v-if="showFileError" />
        </div>

        <label>{{resource('IOFormat_Csv_Separator')}} *</label>
        <div>
            <input type="text" class="form-control" v-model="newSeparator" maxlength="1">
            <required-error fieldName="Separator" v-if="showSeparatorError" />
        </div>
    </div> 
</template>

<script>

import FileUpload from '../../../../Components/Inputs/FileUpload.vue';
import RequiredError from '../../../../Components/Errors/RequiredErrorMessage.vue';

import resources from '../../../../Util/Mixins/resources';
import { validationMixin  } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'csv-format',
    mixins: [resources, validationMixin],
    components: {
        FileUpload,
        RequiredError
    },
    computed: {
        newFile: {
            get() {
                return this.file;
            },
            set(value) {
                this.$emit('update:file', value);
            }
        },
        newSeparator: {
            get() {
                return this.separator;
            },
            set(value) {
                this.$emit('update:separator', value);
            }
        },
        showFileError() {
            return !this.$v.newFile.required;
        },
        showSeparatorError() {
            return !this.$v.newSeparator.required;
        },
        valid() {
            return this.$v.newFile.required && this.$v.newSeparator.required;
        }
    },
    validations: {
        newFile: {
            required
        },
        newSeparator: {
            required
        }
    },
    watch: {
        valid(value) {
            this.$emit('valid', value);
        }
    },
    props: {
        file: {
            required: true
        },
        separator: {
            type: String,
            default: ';'
        }
    }
};
</script>